// Front-end demo configuration.

// Operators selectable at login. The ids MUST match functions/_lib/config.js and
// the operator the BrowserGuard service is initialised with.
export const OPERATORS = {
  LatencyTestBR1: {
    id: 'LatencyTestBR1',
    label: 'LatencyTest BR1',
    region: 'Brazil',
    flag: '🇧🇷',
    // GeoComply Transaction Explorer deep-link. `operator` is the explorer's
    // region-scoped id (<numericId>-<cluster>), NOT the akey. Unknown for these
    // operators — set it to enable per-transaction deep-links; while null the
    // link falls back to a gcTransaction-only lookup.
    explorer: { base: 'https://explorer.geocomply.com/transaction', operator: null },
  },
  LatencyTestLatam: {
    id: 'LatencyTestLatam',
    label: 'LatencyTest LATAM',
    region: 'Latin America',
    flag: '🌎',
    explorer: { base: 'https://explorer.geocomply.com/transaction', operator: null },
  },
};

export const DEFAULT_OPERATOR = 'LatencyTestBR1';

export function operatorMeta(operatorId) {
  return OPERATORS[operatorId] || OPERATORS[DEFAULT_OPERATOR];
}

export function gcExplorerUrl(gcTransaction, operatorId = DEFAULT_OPERATOR) {
  const { base, operator } = operatorMeta(operatorId).explorer || {};
  const b = base || 'https://explorer.geocomply.com/transaction';
  return operator
    ? `${b}?gcTransaction=${gcTransaction}&operator=${operator}`
    : `${b}?gcTransaction=${gcTransaction}`;
}
